import * as types from '../actions/actionTypes';
import { setStorage, getStorage } from '../utils/localStorage';

const initialState = { users: getStorage('usersReducer') || [] };

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_USERS: {
      setStorage('usersReducer', JSON.stringify(action.users));
      return {
        ...state,
        users: action.users,
      };
    }
    default:
      return state;
  }
};
